import "./device-laptop.css";

/**
 * A laptop, drawn in CSS, with whatever you pass it on the glass.
 *
 * Same contract as `DeviceIphone`: content-agnostic. The lid is its own
 * element, hinged at its bottom edge, so a scroll-driven parent can open it
 * while the base stays on the desk: pass `Lid={motion.div}` and a `lidStyle`
 * of motion values.
 *
 * The glass is the console capture's own 1800 x 1013 ratio, so the screen is
 * shown whole rather than cropped to a 16:10 panel.
 */
export default function DeviceLaptop({ children, className = "", Lid = "div", lidStyle, ...rest }) {
  return (
    <div className={`laptop ${className}`.trim()} {...rest}>
      <Lid className="laptop__lid" style={lidStyle}>
        <div className="laptop__bezel">
          <span className="laptop__cam" aria-hidden="true" />
          <div className="laptop__glass">{children}</div>
        </div>
      </Lid>
      <div className="laptop__base" aria-hidden="true">
        <span className="laptop__lip" />
      </div>
    </div>
  );
}
